export default __webpack_public_path__ + "static/media/icons.c656b8ca.ttf";